<div class="dialog-header">
    <h2 mat-dialog-title>Table Settings</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <section class="settings-section">
        <h3 class="section-title">Columns ({{ selectedColumnCount }}/{{ totalColumnCount }})</h3>
        @if (singleGroup) {
            <div class="picker-group">
                @for (col of columnGroups[0].cols; track col) {
                    <mat-checkbox
                        color="primary"
                        [checked]="isSelected(col)"
                        (change)="toggleColumn(col)"
                        class="column-item">
                        {{ labelFor(col) }}
                    </mat-checkbox>
                }
            </div>
        } @else {
            @for (group of columnGroups; track group.label) {
                <div class="picker-group">
                    <mat-checkbox
                        color="primary"
                        [checked]="isGroupAllSelected(group)"
                        [indeterminate]="isGroupIndeterminate(group)"
                        (change)="toggleGroup(group, $event.checked)"
                        class="group-header">
                        {{ group.label }} ({{ groupSelectedCount(group) }}/{{ group.cols.length }})
                    </mat-checkbox>

                    <div class="group-columns">
                        @for (col of group.cols; track col) {
                            <mat-checkbox
                                color="primary"
                                [checked]="isSelected(col)"
                                (change)="toggleColumn(col)"
                                class="column-item">
                                {{ labelFor(col) }}
                            </mat-checkbox>
                        }
                    </div>
                </div>
            }
        }
    </section>

</mat-dialog-content>

<div class="dialog-footer">
    <section class="settings-section inline-fields">
        @if (!hidePageSize) {
            <mat-form-field appearance="outline" class="compact-field">
                <mat-label>Page Size</mat-label>
                <mat-select [(ngModel)]="pageSize">
                    @for (opt of pageSizeOptions; track opt) {
                        <mat-option [value]="opt">{{ opt }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        <mat-form-field appearance="outline" class="compact-field">
            <mat-label>Sort by</mat-label>
            <mat-select [(ngModel)]="sortField">
                @for (col of sortableColumns; track col.value) {
                    <mat-option [value]="col.value">{{ col.label }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="compact-field">
            <mat-label>Direction</mat-label>
            <mat-select [(ngModel)]="sortDirection">
                <mat-option value="asc">Ascending</mat-option>
                <mat-option value="desc">Descending</mat-option>
            </mat-select>
        </mat-form-field>
    </section>

    <div class="save-options">
        <mat-checkbox color="primary" [(ngModel)]="saveAsDefault">Save as my default</mat-checkbox>
        @if (isAdmin) {
            <mat-checkbox color="primary" [(ngModel)]="saveAsAdmin">Set as Company Default</mat-checkbox>
        }
    </div>
</div>

<mat-dialog-actions>
    <button mat-stroked-button (click)="reset()" class="reset-button">Reset to Default</button>
    <span class="spacer"></span>
    <button mat-flat-button color="primary" (click)="apply()">{{ buttonLabel }}</button>
</mat-dialog-actions>
